<template>
    <div>
        <div class="rtitle flex justify-between align-center bg-white rone">
            <div class="colorleft">联系我们</div>
            <div class="colorright"></div>
        </div>
        <div class="cball">
            <div class="bg-white" style="min-height: 570px;">
                <el-row>
                    <el-col class="contact flex align-center" :span="24">
                        <el-image class="c_img" src="/static/assets/images/icon1.png" fit="fill"></el-image>
                        <div class="">{{config.people}}{{config.phone}}</div>
                    </el-col>
                    <el-col class="contact flex align-center" :span="24">
                        <el-image class="c_img" src="/static/assets/images/icon2.png" fit="fill"></el-image>
                        <div class="">{{config.email}}</div>
                    </el-col>
                    <el-col class="contact flex align-center" :span="24">
                        <el-image class="c_img" src="/static/assets/images/icon3.png" fit="fill"></el-image>
                        <div class="">{{config.address}}</div>
                    </el-col>
                </el-row>
            </div>
        </div>
        
    </div>
</template>
<script>
export default ({
    data() {
        return{
            config: ''
        }
    },
    methods:{
        getconfig(){
            this.$api.index.config().then(res=>{
                this.config = res.data;
            })
        },
    },
    created(){
        this.getconfig();
    }
})
</script>

<style scoped>
    .rtitle{
        padding: 20px;
        font-size: 16px;
        color: #7d7d7d;
        border-bottom: 8px solid #f4f4f4;
    }
    .rone{
        border-radius: 12px 12px 0 0;
    }
    .colorleft{
        color: #191919;font-size: 20px;
    }
    .colorright{
        color: #7e7e7e;font-size: 18px;
    }





    .cball{
        border-radius: 0 0 12px 12px;overflow:hidden;
    }
    .c_img{
        width: 33px;height: 33px;margin-right: 15px;
    }
    .contact{
        height: 105px;
        line-height: 105px;
        border-bottom: 1px solid #eee;
        padding: 0 60px;
    }
</style>


// WEBPACK FOOTER //
// concat_us.vue?473e8311